import { useMemo, type JSX } from "react";
import { type BikeTypeV2 } from "@jobrad-gmbh/bike-leasing-calculator";
import { SimpleRadioGroup } from "../SimpleRadioGroup";
import { useI18n } from "../../i18n";

type BikeTypeSelectProps = {
  availableBikeTypes: BikeTypeV2[];
  selectedBikeType: BikeTypeV2;
  onValueChanged: (selectedBikeType: BikeTypeV2) => void;
  ariaLabelledBy?: string;
};

const BikeTypeSelect = (props: BikeTypeSelectProps): JSX.Element => {
  const { availableBikeTypes, selectedBikeType, onValueChanged, ariaLabelledBy } = props;
  const { t } = useI18n();

  const onChange = (newSelectionValue: string) => {
    onValueChanged(newSelectionValue as BikeTypeV2);
  };

  const bikeTypeOptions = useMemo(() => {
    return availableBikeTypes.map((bikeType: BikeTypeV2) => ({
      name: t(`bikeTypeOptions.${bikeType}`),
      value: bikeType,
    }));
  }, [availableBikeTypes, t]);

  return (
    <SimpleRadioGroup
      options={bikeTypeOptions}
      variant="toggleButton"
      onValueChangedParse={onChange}
      name="bikeTypeSelect"
      value={selectedBikeType}
      ariaLabelledBy={ariaLabelledBy}
    />
  );
};

export { BikeTypeSelect };
